module.exports = __webpack_public_path__ + "static/media/left-align.25af63f2.svg";